var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2068_34058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64133 1.72629C5.75657 1.49282 5.81419 1.37609 5.89241 1.33879C5.96047 1.30634 6.03954 1.30634 6.1076 1.33879C6.18583 1.37609 6.24345 1.49282 6.35869 1.72629L7.45203 3.94128C7.48605 4.0102 7.50306 4.04466 7.52792 4.07142C7.54994 4.09511 7.57633 4.11431 7.60566 4.12794C7.63878 4.14335 7.6768 4.1489 7.75286 4.16002L10.1985 4.51749C10.456 4.55513 10.5848 4.57395 10.6444 4.63685C10.6962 4.69158 10.7206 4.76678 10.7108 4.84152C10.6994 4.92742 10.6062 5.01822 10.4197 5.19982L8.65072 6.92284C8.59558 6.97655 8.56801 7.00341 8.55021 7.03536C8.53446 7.06366 8.52435 7.09474 8.52046 7.12689C8.51605 7.16319 8.52256 7.20113 8.53557 7.277L8.95298 9.71069C8.997 9.96738 9.01902 10.0957 8.97765 10.1719C8.94166 10.2381 8.87768 10.2846 8.80353 10.2984C8.71831 10.3142 8.60306 10.2536 8.37256 10.1323L6.18619 8.98255C6.11807 8.94673 6.08401 8.92881 6.04812 8.92178C6.01635 8.91554 5.98367 8.91554 5.9519 8.92178C5.91601 8.92881 5.88195 8.94673 5.81383 8.98255L3.62746 10.1323C3.39696 10.2536 3.28171 10.3142 3.19649 10.2984C3.12234 10.2846 3.05836 10.2381 3.02237 10.1719C2.981 10.0957 3.00301 9.96738 3.04704 9.71069L3.46444 7.277C3.47746 7.20113 3.48396 7.16319 3.47956 7.12689C3.47566 7.09474 3.46556 7.06366 3.4498 7.03536C3.43201 7.00341 3.40444 6.97655 3.34929 6.92284L1.58028 5.19982C1.39383 5.01822 1.30061 4.92742 1.28926 4.84152C1.27939 4.76678 1.30378 4.69158 1.35563 4.63685C1.41522 4.57395 1.54399 4.55513 1.80152 4.51749L4.24716 4.16002C4.32321 4.1489 4.36124 4.14335 4.39436 4.12794C4.42368 4.11431 4.45008 4.09511 4.47209 4.07142C4.49695 4.04466 4.51396 4.0102 4.54799 3.94128L5.64133 1.72629Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2068_34058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminStar);
export default __webpack_public_path__ + "static/media/admin_star.adc9356be48ab1461bd8f170df327597.svg";
export { ForwardRef as ReactComponent };